import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginModal, setOpenSignUpModal } from "../../../redux/userSlice.js";
import { RoundedButton } from "../../RoundedButtons/index.js";

import NotificationIcon from "../../../assets/Images/icons/notificationIcon.svg";

import ProfileIcon from "../../../assets/Images/icons/profileIcon.svg";
import Card from "../../Card.js";
import { useState } from "react";
import { Button } from "../../Buttons/index.js";
import UserDetailList from "./UserDetailList.js";
import MobileCanvas from "./MobileCanvas.js";
import NotificationList from "./NotificationList.js";
import SidebarList from "./SidebarList.js";

const LoginHeaderContainer = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);
  const { isAuthenticated: isLoggedIn } = user;
  const [mobileMenu, setMobileMenu] = useState(false);
  const [NotMobileMenu, setNotMobileMenu] = useState(false);
  const onClickLogin = () => {
    dispatch(setOpenLoginModal(true));
  }
  const [navbarStates, setNavbarStates] = useState({
    showNavMenu: false,
    showNotificationMenu: false,
  });
  const onClickSignUp = () => {
    dispatch(setOpenSignUpModal(true));
  }
  const notificationNavHandler = () => {
    setNotMobileMenu(!NotMobileMenu);
    navbarStateHandler("showNotificationMenu", !navbarStates.showNotificationMenu);
  }
  const profileNavHandler = () => {
    setMobileMenu(!mobileMenu);
    navbarStateHandler("showNavMenu", !navbarStates.showNavMenu);
  };
  const navbarStateHandler = (key, value) => {

    setNavbarStates((prevState) => ({ ...prevState, [key]: value }));
  };

  return (<div className="flex relative flex-row gap-[10px]">
    {isLoggedIn ? (
      <>
        <div className="relative">
          <RoundedButton variant="secondary" onClick={notificationNavHandler}>
            <img src={NotificationIcon} />
          </RoundedButton>
          {navbarStates?.showNotificationMenu && (
            <div className="hidden md:block absolute top-14 right-2 min-w-[500px] z-50">
              <Card className={"py-[12px]"}>
                <NotificationList />
              </Card>
            </div>
          )}
        </div>

        <RoundedButton className={"relative"} onClick={profileNavHandler}>
          <img src={ProfileIcon} />
        </RoundedButton>
        {navbarStates?.showNavMenu && (
          <div className="hidden lg:block absolute top-14 right-0 min-w-[220px] z-50">
            <Card className={"py-[12px]"}>
              <UserDetailList />
            </Card>
          </div>
        )}
      </>
    ) : (
      <>
        <div>
          <Button
            title="Log in"
            onClick={onClickLogin}
            variant="tertiary"
            className=" !bg-primary text-white md:!bg-white md:!text-primary"
          />
        </div>

        <div className=" hidden md:block">
          <Button
            title="Sign Up"
            className=""
            onClick={onClickSignUp}
          />
        </div>
      </>
    )}
    {mobileMenu &&
      <MobileCanvas mobileMenu={mobileMenu} setmobileMenu={setMobileMenu}
        className={"block  lg:hidden"}
      >
        <div>
          <SidebarList className={"pl-[20px]"} />
        </div>
      </MobileCanvas>}
    {NotMobileMenu && <MobileCanvas mobileMenu={NotMobileMenu} setmobileMenu={setNotMobileMenu} >
      <div className="">
        <NotificationList />
      </div>
    </MobileCanvas>
    }
  </div>)
}

export default LoginHeaderContainer;